var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showTerms)?_c('TermsModal'):_vm._e(),(_vm.showMfa)?_c('AddMfa'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }